import React from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Select from 'b2b-ui-components-lib/lib/components/select';
import '../../addressProcess/processComponent/processComponent.scss';
import { isUserTypeIsKAM } from '../configure-plan-pricing-constant';
import Tooltip from 'common/components/tooltip-component/tooltip-component';
import { TOOLTIP_MESSAGE } from 'home/view/manage-feasibility/constants/multiSite-constants';
import emailIcon from 'assests/svg/email.svg';
import needAssitanceIcon from 'assests/svg/needAssitance.svg';
import settingIcon from 'assests/svg/setting.svg';
import { isNLD_OR_LL, isBulkUpgrade } from 'common/constants/app.constants';

const MainHeader = ({
  orderId,
  feasibileSite,
  onViewAvailableConfiguration,
  onEmailPricing,
  onNeedAssistance,
  onConfigSiteWithExcel,
  blockJourney,
  finalPrice,
  isSameMedia,
  rateCardIdList,
  selectedRateCardId,
  handleRateCardIdChange
}) => {
  return (
    <ul className="process_items">
      <li>
        <div className="servics_title">
          <span className="ttl_lable">Order Request ID:&nbsp;</span>
          <span className="service_value">{orderId}</span>
        </div>
      </li>
      <li>
        <div className="servics_title">
          <span className="total_count">{isNLD_OR_LL() ? Math.floor(feasibileSite / 2) : feasibileSite}</span>
          <span className="ttl_lable">{isNLD_OR_LL() ? 'Total Links' : 'Total Feasible Sites'}</span>
        </div>
      </li>
      <li>
        <Tooltip message={TOOLTIP_MESSAGE.CONFIGURE_SITE_WITH_EXCEL}>
          <Button disabled={isSameMedia ? false : blockJourney || feasibileSite === 0} onClick={onConfigSiteWithExcel}>
            Configure Sites with Excel
          </Button>
        </Tooltip>
      </li>
      {/* {!(isNLD_OR_LL() || isBulkUpgrade()) && (
        <li>
          <Tooltip message={TOOLTIP_MESSAGE.VIEW_AVAILABLE_CONFIGURATION}>
            <span className="btn_text" onClick={onViewAvailableConfiguration}>
              <img src={settingIcon} alt="View Available Configuration" loading="lazy"></img>
              View Available Configuration
            </span>
          </Tooltip>
        </li>
      )} */}

      {!isUserTypeIsKAM() && (
        <React.Fragment>
          <li>
            <Tooltip message={TOOLTIP_MESSAGE.EMAIL_PRICING_PROPOSAL}>
              <span disabled={blockJourney || !finalPrice || feasibileSite === 0 || isBulkUpgrade()} className="btn_text" onClick={onEmailPricing}>
                <img src={emailIcon} alt="Email Pricing Proposal" loading="lazy"></img>
                Email Pricing Proposal
              </span>
            </Tooltip>
          </li>
          <li>
            <Tooltip message={TOOLTIP_MESSAGE.NEED_ASSISTANCE}>
              <span className="btn_text" disabled={blockJourney || feasibileSite === 0} onClick={onNeedAssistance}>
                <img src={needAssitanceIcon} alt="Need Assistance" loading="lazy"></img>
                Need Assistance
              </span>
            </Tooltip>
          </li>
          {!isBulkUpgrade() && (
            <li>
              <Select
                placeholder=""
                label="Rate Card Id"
                value={selectedRateCardId}
                onChange={handleRateCardIdChange}
                options={rateCardIdList}
                disabled={blockJourney || feasibileSite === 0}
                required
              />
            </li>
          )}
        </React.Fragment>
      )}
    </ul>
  );
};

export default MainHeader;
